import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Microphone01 = function Microphone01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 10v2c0 3.866-3.134 7-7 7m-7-9v2c0 3.866 3.134 7 7 7m0 0v3m-4 0h8m-4-7c-1.6569 0-3-1.3431-3-3V5c0-1.6568 1.3431-3 3-3s3 1.3432 3 3v7c0 1.6569-1.3431 3-3 3"
    })
  }));
};
export default Microphone01;